<template let-data>
  <div class="card-template">
    <div class="e-card-header">
      <div class="e-card-header-caption">
        <div class="e-card-header-title e-tooltip-text">{{ data.nome }} ({{ data.id }})</div>
      </div>
    </div>
    <div class="e-card-content e-tooltip-text">
      <div class="e-text">{{data.resumo}}</div>
    </div>
    <div class="e-card-custom-footer" v-html="getCardFooter(data)"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      data: {}
    };
  },
  methods: {
    getString: function(name) {
      return name.match(/\b(\w)/g).join("").toUpperCase();
    },
    getCardFooter: function(data) {
      let tagDiv = "";
      if (data.tags) {
        let tags = data.tags.split(",");
        for (let tag of tags) {
          tagDiv += "<div class='e-card-tag-field e-tooltip-text'>" + tag + "</div>";
        }
        tagDiv += "<div class='e-card-avatar'>" + data.pontos + "</div>";
        return tagDiv;
      } else {
        return "<div class='e-card-avatar'>" + data.pontos + "</div>";
      }
    }
  }
};
</script>
